import { ValueConditionalStylesProps, SelectorInputTypeProps } from "../Interface"

// This just renders the value with some css
export function SelectorBase({value, onClick, conditionalStyles}: {value: SelectorInputTypeProps, onClick: () => void, conditionalStyles?: ValueConditionalStylesProps[]}) {
    const style = conditionalStyles?.find((style) => style.when(value))?.style
    console.log(`SelectorBase - Value: ${value}, Found style:`, style)

    return (
        <div className="flex flex-row p-2 border border-gray-300 rounded-md hover:cursor-pointer" onClick={onClick} style={style} tabIndex={0}>
            {value ?? "N/A"}
        </div>
    )
}

export function FormatFieldName(field_name: string | null | undefined) {
    if (!field_name) return "Unknown Field"
    return field_name.includes("_") ? field_name.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") : field_name.charAt(0).toUpperCase() + field_name.slice(1)
}